import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="relative flex min-h-screen items-center justify-center overflow-hidden navy-mesh px-6 py-16 text-white">
      <div className="pointer-events-none absolute -left-32 top-10 h-96 w-96 rounded-full bg-brand/20 blur-3xl" />
      <div className="relative w-full max-w-lg text-center">
        <div className="mb-10 flex justify-center"><Logo light /></div>
        <div className="rounded-3xl border border-white/10 bg-white/5 p-12 backdrop-blur">
          <XCircle className="mx-auto h-12 w-12 text-slate-400" />
          <h1 className="mt-6 font-display text-3xl font-black tracking-tight">Checkout canceled</h1>
          <p className="mt-4 text-lg leading-relaxed text-slate-300">No worries — you haven't been charged. Whenever you're ready to grow, your plan will be right here.</p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="cancel-home-link" className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white hover:border-brand">
              <ArrowLeft className="h-4 w-4" /> Back to home
            </Link>
            <Link to="/#packages" className="rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white hover:bg-brand-hover">View plans</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
